export {default} from "./Table";


// WEBPACK FOOTER //
// ./src/components/Table/index.js